'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user';
var width = 448;
var height = 512;
var aliases = [128100,62144,62470,"user-alt","user-large"];
var unicode = 'f007';
var svgPathData = ['M104 128a120 120 0 1 0 240 0 120 120 0 1 0 -240 0z', 'M16 482.3C16 383.8 95.8 304 194.3 304l59.4 0c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7L45.7 512C29.3 512 16 498.7 16 482.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;